import axios from "axios";
import { jwtDecode } from "jwt-decode";

import config from "../../../../config"
import * as actions from "../actions"


const setLocalStorage = async (accessToken, refreshToken, userId, isAuth) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("userId", userId);
  localStorage.setItem("isAuth", isAuth);
}

const resetLocalStorage = async () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("userId")
  localStorage.removeItem("isAuth");
}

export const fetchUserHandler = (userId = localStorage.getItem("userId")) => {
  const headers = {
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("accessToken")}`,
      "Content-Type": "application/json",
    }
  }
  return async dispatch => {
    try {
      dispatch(actions.requestStart());
      let { data } = await axios.get(`${config.baseUrl}/users/me`, headers)
      if (data) {
        await dispatch(actions.requestUserSuccess(data));
      }
      return data
    }
    catch (error) {
      await dispatch(actions.requestFail(error));
    }
  }
}

export const loginHandler = (formData) => {
  return async dispatch => {
    try {
      dispatch(actions.requestStart());
      const response = await axios.post(`${config.baseUrl}/auth/login`, formData);
      dispatch(actions.requestSuccess());
      return response
    }
    catch (error) {
      await dispatch(actions.requestFail(error));
      return null
    }
  }
}

export const verifyHandler = (formData) => {
  return async dispatch => {
    try {
      dispatch(actions.requestStart());
      const response = await axios.post(`${config.baseUrl}/auth/verify`, formData);
      const { status, data } = response

      if (status === 200) {
        const { sub } = await jwtDecode(data.access_token)

        await setLocalStorage(data.access_token, data.refresh_token, sub, 'true');
        await dispatch(fetchUserHandler(sub))
        dispatch(actions.requestSuccess());
        return response
      }
    }
    catch (error) {
      await dispatch(actions.requestFail(error));
      return null
    }
  }
}

export const logoutHandler = (history) => {
  return async dispatch => {
    resetLocalStorage()
    dispatch(actions.requestLogoutSuccess());
  }
}

export const clearErrorHandler = () => {
  return dispatch => {
    dispatch(actions.clearError());
  }
}

export const refreshTokenHandler = () => {
  return async dispatch => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      
      if (!refreshToken) {
        throw new Error("No refresh token available");
      }
      
      const response = await axios.post(`${config.baseUrl}/auth/refresh`, {
        refresh_token: refreshToken
      });
      
      if (response?.status === 200 && response?.data?.access_token) {
        const { access_token, refresh_token } = response.data;
        
        localStorage.setItem("accessToken", access_token);
        if (refresh_token) {
          localStorage.setItem("refreshToken", refresh_token);
        }
        
        const { sub } = jwtDecode(access_token);
        localStorage.setItem("userId", sub);
        
        dispatch(actions.tokenRefreshSuccess({ access_token, refresh_token }));
        return response;
      } else {
        throw new Error("Failed to refresh token");
      }
    } catch (error) {
      console.error("Token refresh failed:", error);

      await dispatch(logoutHandler());
      throw error;
    }
  }
}
